(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7506],{

/***/ 54302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": function() { return /* binding */ breakpoints; },
/* harmony export */   "XQ": function() { return /* binding */ mapResponsive; },
/* harmony export */   "Yq": function() { return /* binding */ arrayToObjectNotation; }
/* harmony export */ });
/* unused harmony exports analyzeBreakpoints, isCustomBreakpoint, isResponsiveObjectLike, objectToArrayNotation, px, toMediaQueryString */
// ../shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/responsive.ts
var breakpoints = Object.freeze([
  "base",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl"
]);
function mapResponsive(prop, mapper) {
  if (Array.isArray(prop)) {
    return prop.map((item) => item === null ? null : mapper(item));
  }
  if (isObject(prop)) {
    return Object.keys(prop).reduce((result, key) => {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }
  if (prop != null) {
    return mapper(prop);
  }
  return null;
}
function objectToArrayNotation(obj, bps = breakpoints) {
  const result = bps.map((br) => obj[br] ?? null);
  const lastItem = result[result.length - 1];
  while (lastItem === null)
    result.pop();
  return result;
}
function arrayToObjectNotation(values, bps = breakpoints) {
  const result = {};
  values.forEach((value, index) => {
    const key = bps[index];
    if (value == null)
      return;
    result[key] = value;
  });
  return result;
}
function isResponsiveObjectLike(obj, bps = breakpoints) {
  const keys2 = Object.keys(obj);
  return keys2.length > 0 && keys2.every((key) => bps.includes(key));
}
var isCustomBreakpoint = (v) => Number.isNaN(Number(v));

// src/breakpoint.ts
function getLastItem(array) {
  const length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
function analyzeCSSValue(value) {
  const num = parseFloat(value.toString());
  const unit = value.toString().replace(String(num), "");
  return { unitless: !unit, value: num, unit };
}
function px(value) {
  if (value == null)
    return value;
  const { unitless } = analyzeCSSValue(value);
  return unitless || typeof value === "number" ? `${value}px` : value;
}
var sortByBreakpointValue = (a, b) => parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var sortBps = (breakpoints2) => Object.fromEntries(Object.entries(breakpoints2).sort(sortByBreakpointValue));
function normalize(breakpoints2) {
  const sorted = sortBps(breakpoints2);
  return Object.assign(Object.values(sorted), sorted);
}
function keys(breakpoints2) {
  const value = Object.keys(sortBps(breakpoints2));
  return new Set(value);
}
function subtract(value) {
  if (!value)
    return value;
  value = px(value) ?? value;
  const factor = value.endsWith("px") ? -1 : -0.0625;
  return typeof value === "number" ? `${value + factor}` : value.replace(/(\d+\.?\d*)/u, (m) => `${parseFloat(m) + factor}`);
}
function toMediaQueryString(min, max) {
  const query = ["@media screen"];
  if (min)
    query.push("and", `(min-width: ${px(min)})`);
  if (max)
    query.push("and", `(max-width: ${px(max)})`);
  return query.join(" ");
}
function analyzeBreakpoints(breakpoints2) {
  if (!breakpoints2)
    return null;
  breakpoints2.base = breakpoints2.base ?? "0px";
  const normalized = normalize(breakpoints2);
  const queries = Object.entries(breakpoints2).sort(sortByBreakpointValue).map(([breakpoint, minW], index, entry) => {
    let [, maxW] = entry[index + 1] ?? [];
    maxW = parseFloat(maxW) > 0 ? subtract(maxW) : void 0;
    return {
      _minW: subtract(minW),
      breakpoint,
      minW,
      maxW,
      maxWQuery: toMediaQueryString(null, maxW),
      minWQuery: toMediaQueryString(minW),
      minMaxQuery: toMediaQueryString(minW, maxW)
    };
  });
  const _keys = keys(breakpoints2);
  const _keysArr = Array.from(_keys.values());
  return {
    keys: _keys,
    normalized,
    isResponsive(test) {
      const keys2 = Object.keys(test);
      return keys2.length > 0 && keys2.every((key) => _keys.has(key));
    },
    asObject: sortBps(breakpoints2),
    asArray: normalize(breakpoints2),
    details: queries,
    media: [
      null,
      ...normalized.map((minW) => toMediaQueryString(minW)).slice(1)
    ],
    toArrayValue(test) {
      if (!isObject(test)) {
        throw new Error("toArrayValue: value must be an object");
      }
      const result = _keysArr.map((bp) => test[bp] ?? null);
      while (getLastItem(result) === null) {
        result.pop();
      }
      return result;
    },
    toObjectValue(test) {
      if (!Array.isArray(test)) {
        throw new Error("toObjectValue: value must be an array");
      }
      return test.reduce((acc, value, index) => {
        const key = _keysArr[index];
        if (key != null && value != null)
          acc[key] = value;
        return acc;
      }, {});
    }
  };
}



/***/ }),

/***/ 71099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Od": function() { return /* binding */ Skeleton; },
  "s7": function() { return /* binding */ SkeletonCircle; },
  "N2": function() { return /* binding */ SkeletonText; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 3 modules
var index_esm = __webpack_require__(83961);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-env/dist/index.esm.js
var dist_index_esm = __webpack_require__(18229);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breakpoint-utils/dist/index.esm.js
var breakpoint_utils_dist_index_esm = __webpack_require__(54302);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,index_esm/* useTheme */.Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,dist_index_esm/* useEnvironment */.O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,index_esm/* useTheme */.Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = breakpoint_utils_dist_index_esm/* breakpoints */.AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,index_esm/* useTheme */.Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,breakpoint_utils_dist_index_esm/* arrayToObjectNotation */.Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";


// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.esm.js
var styled_system_dist_index_esm = __webpack_require__(54520);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-use-previous/dist/index.esm.js
// src/index.ts

function usePrevious(value) {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}


;// CONCATENATED MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js
// ../../../react-shim.js


// src/skeleton.tsx




// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// src/skeleton.tsx

var StyledSkeleton = (0,index_esm/* chakra */.m$)("div", {
  baseStyle: {
    boxShadow: "none",
    backgroundClip: "padding-box",
    cursor: "default",
    color: "transparent",
    pointerEvents: "none",
    userSelect: "none",
    "&::before, &::after, *": {
      visibility: "hidden"
    }
  }
});
var useIsFirstRender = () => {
  const isFirstRender = (0,react.useRef)(true);
  (0,react.useEffect)(() => {
    isFirstRender.current = false;
  }, []);
  return isFirstRender.current;
};
var fade = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: { opacity: 0 },
  to: { opacity: 1 }
});
var startColor = "var(--skeleton-start-color)";
var endColor = "var(--skeleton-end-color)";
var bgFade = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: { borderColor: startColor, background: startColor },
  to: { borderColor: endColor, background: endColor }
});
var Skeleton = (0,index_esm/* forwardRef */.Gp)((props, ref) => {
  const styles = (0,index_esm/* useStyleConfig */.mq)("Skeleton", props);
  const isFirstRender = useIsFirstRender();
  const {
    startColor: startColor2,
    endColor: endColor2,
    isLoaded,
    fadeDuration,
    speed,
    className,
    ...rest
  } = (0,styled_system_dist_index_esm/* omitThemingProps */.Lr)(props);
  const wasPreviouslyLoaded = usePrevious(isLoaded);
  const _className = cx("chakra-skeleton", className);
  if (isLoaded) {
    const animation = isFirstRender || wasPreviouslyLoaded ? "none" : `${fade} ${fadeDuration}s`;
    return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
      ref,
      className: _className,
      __css: { animation },
      ...rest
    });
  }
  return /* @__PURE__ */ react.createElement(StyledSkeleton, {
    ref,
    className: _className,
    ...rest,
    __css: {
      ...styles,
      animation: `${speed}s linear infinite alternate ${bgFade}`
    }
  });
});
Skeleton.defaultProps = {
  fadeDuration: 0.4,
  speed: 0.8
};
Skeleton.displayName = "Skeleton";
function range(count) {
  return Array(count).fill(1).map((_, index) => index + 1);
}
var defaultNoOfLines = 3;
var SkeletonText = (props) => {
  const {
    noOfLines = defaultNoOfLines,
    spacing = "0.5rem",
    skeletonHeight = "0.5rem",
    className,
    startColor: startColor2,
    endColor: endColor2,
    isLoaded,
    fadeDuration,
    speed,
    children,
    ...rest
  } = props;
  const noOfLinesValue = useBreakpointValue(typeof noOfLines === "number" ? [noOfLines] : noOfLines) || defaultNoOfLines;
  const numbers = range(noOfLinesValue);
  const getWidth = (index) => {
    if (noOfLinesValue > 1) {
      return index === numbers.length ? "80%" : "100%";
    }
    return "100%";
  };
  const _className = cx("chakra-skeleton__group", className);
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    className: _className,
    ...rest
  }, numbers.map((number, index) => {
    if (isLoaded && index > 0) {
      return null;
    }
    const sizeProps = isLoaded ? null : {
      mb: number === numbers.length ? "0" : spacing,
      width: getWidth(number),
      height: skeletonHeight
    };
    return /* @__PURE__ */ react.createElement(Skeleton, {
      key: numbers.length.toString() + number,
      startColor: startColor2,
      endColor: endColor2,
      isLoaded,
      fadeDuration,
      speed,
      ...sizeProps
    }, index === 0 ? children : void 0);
  }));
};
SkeletonText.displayName = "SkeletonText";
var SkeletonCircle = ({
  size = "2rem",
  ...rest
}) => /* @__PURE__ */ react.createElement(Skeleton, {
  borderRadius: "full",
  boxSize: size,
  ...rest
});
SkeletonCircle.displayName = "SkeletonCircle";



/***/ }),

/***/ 74474:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password-recovery",
      function () {
        return __webpack_require__(61453);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ password_recovery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/constants/routes.ts
var routes = __webpack_require__(224);
// EXTERNAL MODULE: ./src/shared/hooks/useToast.ts
var useToast = __webpack_require__(64390);
// EXTERNAL MODULE: ./node_modules/react-icons/im/index.esm.js
var index_esm = __webpack_require__(53990);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
;// CONCATENATED MODULE: ./src/modules/auth/assets/data/passwordRecoveryMethodsOptions.ts


const passwordRecoveryMethodsOptions = [
    {
        title: "Whatsapp",
        description: "O c\xf3digo ser\xe1 enviado por Whatsapp",
        value: "whatsapp",
        icon: index_esm/* ImWhatsapp */.KXk
    },
    {
        title: "E-mail",
        value: "email",
        description: "O c\xf3digo ser\xe1 enviado por e-mail",
        icon: fi_index_esm/* FiMail */.Imn
    },
    {
        title: "SMS",
        value: "sms",
        description: "O c\xf3digo ser\xe1 enviado por SMS",
        icon: fi_index_esm/* FiMessageSquare */.IC0
    }
];

// EXTERNAL MODULE: ./src/shared/utils/masks.ts
var masks = __webpack_require__(33613);
// EXTERNAL MODULE: ./src/shared/services/api/index.ts + 1 modules
var api = __webpack_require__(7921);
;// CONCATENATED MODULE: ./src/modules/auth/services/passwordRecovery.ts

async function validateUserRecoveryCode(passwordRecoveryCode) {
    const response = await api/* api.post */.hi.post("/admin-users/validate-password-recovery-code", {
        passwordRecoveryCode
    });
    return response.data;
}
async function sendUserPasswordRecoveryCode(data) {
    await api/* api.post */.hi.post("/admin-users/send-password-recovery-code", data);
}
async function resetUserPassword(data) {
    await api/* api.post */.hi.post("/admin-users/reset-password", data);
}

;// CONCATENATED MODULE: ./src/modules/auth/hooks/usePasswordRecovery.tsx








const PasswordRecoveryContext = /*#__PURE__*/ (0,react.createContext)({});
const PasswordRecoveryProvider = (param)=>{
    let { children  } = param;
    const toast = (0,useToast/* useToast */.p)();
    const router = (0,next_router.useRouter)();
    const formData = (0,react.useRef)({});
    const [currentStep, setCurrentStep] = (0,react.useState)(1);
    const [sendRecoveryCodeError, setSendRecoveryCodeError] = (0,react.useState)(undefined);
    const [validateRecoveryCodeError, setValidateRecoveryCodeError] = (0,react.useState)(undefined);
    const [recoveryCodeIsValidating, setRecoveryCodeIsValidating] = (0,react.useState)(false);
    const setFormData = (0,react.useCallback)((data)=>{
        const newFormData = {
            ...formData.current,
            ...data || {}
        };
        formData.current = newFormData;
        return newFormData;
    }, []);
    const getFormData = (0,react.useCallback)((field)=>{
        return formData.current[field];
    }, []);
    const nextStep = (0,react.useCallback)((data)=>{
        setCurrentStep((prevState)=>prevState + 1);
        setFormData(data);
    }, [
        setFormData
    ]);
    const previousStep = (0,react.useCallback)(()=>{
        setCurrentStep((prevState)=>prevState - 1);
    }, []);
    const sendRecoveryCode = (0,react.useCallback)(async (data)=>{
        try {
            setSendRecoveryCodeError("");
            const newFormData = setFormData(data);
            await sendUserPasswordRecoveryCode({
                method: newFormData.method,
                value: newFormData.method === "email" ? newFormData.value : (0,masks/* unmask */.ec)(newFormData.value)
            });
            nextStep();
        } catch (error) {
            var ref, ref1;
            if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.tag) === "USER_NOT_FOUND") {
                setSendRecoveryCodeError("Nenhuma conta encontrada");
                return;
            }
            toast.show({
                title: "Ops, n\xe3o foi poss\xedvel enviar o c\xf3digo de recupera\xe7\xe3o!",
                description: "Recarregue a p\xe1gina e tente novamente.",
                variant: "error"
            });
        }
    }, [
        nextStep,
        setFormData,
        toast
    ]);
    const validateRecoveryCode = (0,react.useCallback)(async (data)=>{
        try {
            setValidateRecoveryCodeError("");
            setRecoveryCodeIsValidating(true);
            const newFormData = setFormData(data);
            const userExists = await validateUserRecoveryCode(newFormData.code.toUpperCase());
            if (!userExists) {
                setValidateRecoveryCodeError("C\xf3digo de recupera\xe7\xe3o inv\xe1lido");
                return;
            }
            nextStep();
        } catch (error) {
            toast.show({
                title: "Ops, n\xe3o foi poss\xedvel verificar esse c\xf3digo de recupera\xe7\xe3o!",
                description: "Recarregue a p\xe1gina e tente novamente",
                variant: "error"
            });
        } finally{
            setRecoveryCodeIsValidating(false);
        }
    }, [
        nextStep,
        setFormData,
        toast
    ]);
    const resetPassword = (0,react.useCallback)(async (data)=>{
        try {
            const newFormData = setFormData(data);
            await resetUserPassword({
                newPassword: data.newPassword,
                passwordRecoveryCode: newFormData.code.toUpperCase()
            });
            toast.show({
                title: "Boa, sua senha foi alterada com sucesso!",
                description: "Fa\xe7a o seu login para entrar no portal.",
                variant: "success"
            });
            router.push(routes/* routes.AUTH.SIGN_IN */._.AUTH.SIGN_IN);
        } catch (error) {
            var ref, ref1, ref2, ref3;
            toast.show({
                title: "Ops, n\xe3o foi poss\xedvel redefinir a sua senha!",
                description: (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.displayMessage) || (error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || "Recarregue a p\xe1gina e tente novamente.",
                variant: "error"
            });
        }
    }, [
        router,
        setFormData,
        toast
    ]);
    const changeMethod = (0,react.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    const selectedMethod = getFormData("method");
    const selectedMethodOption = (0,react.useMemo)(()=>{
        return passwordRecoveryMethodsOptions.find((item)=>item.value === selectedMethod);
    }, [
        selectedMethod
    ]);
    const contextData = (0,react.useMemo)(()=>({
            currentStep,
            nextStep,
            previousStep,
            sendRecoveryCode,
            validateRecoveryCode,
            resetPassword,
            changeMethod,
            sendRecoveryCodeError,
            recoveryCodeIsValidating,
            validateRecoveryCodeError,
            selectedMethod,
            selectedMethodOption
        }), [
        currentStep,
        nextStep,
        previousStep,
        sendRecoveryCode,
        validateRecoveryCode,
        resetPassword,
        changeMethod,
        sendRecoveryCodeError,
        recoveryCodeIsValidating,
        validateRecoveryCodeError,
        selectedMethod,
        selectedMethodOption
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordRecoveryContext.Provider, {
        value: contextData,
        children: children
    });
};
const usePasswordRecovery = ()=>{
    return (0,react.useContext)(PasswordRecoveryContext);
};


// EXTERNAL MODULE: ./src/shared/components/AuthHeader/index.tsx + 1 modules
var AuthHeader = __webpack_require__(41961);
// EXTERNAL MODULE: ./src/shared/hooks/useElementSize.ts + 2 modules
var useElementSize = __webpack_require__(83896);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/modules/auth/components/PasswordRecoverySteps/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from { opacity: 0; }\n  to { opacity: 1; }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  animation: ",
        " 0.3s ease-in;\n\n  > div {\n    display: flex;\n\n    transition: transform 0.3s ease-in;\n\n    width: ",
        "px;\n    transform: ",
        ";\n\n    > form {\n      width: ",
        "px;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13112e5c-0"
})(_templateObject1(), fadeIn, (param)=>{
    let { width  } = param;
    return width * 4;
}, (param)=>{
    let { width , currentStep  } = param;
    return "translateX(-".concat(width * (currentStep - 1), "px)");
}, (param)=>{
    let { width  } = param;
    return width;
});

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./src/shared/components/Form/FormGroup/index.tsx + 1 modules
var FormGroup = __webpack_require__(24293);
// EXTERNAL MODULE: ./src/shared/components/Form/CustomRadio/index.tsx
var CustomRadio = __webpack_require__(54815);
// EXTERNAL MODULE: ./src/shared/components/Form/ControlledInput/index.tsx
var ControlledInput = __webpack_require__(23058);
// EXTERNAL MODULE: ./src/shared/components/Collapse/index.tsx
var Collapse = __webpack_require__(89903);
// EXTERNAL MODULE: ./src/shared/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(67399);
// EXTERNAL MODULE: ./src/shared/components/AuthLink/index.tsx + 1 modules
var AuthLink = __webpack_require__(22025);
;// CONCATENATED MODULE: ./src/modules/auth/components/PasswordRecoverySteps/StepWrapper/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: opacity 0.3s ease-in, height 0.3s ease-out 0.3s;\n  overflow: hidden;\n\n  opacity: ",
        ";\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}

const styles_Container = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-b84f2d9b-0"
})(styles_templateObject(), (param)=>{
    let { currentStep , step  } = param;
    return currentStep === step ? 1 : 0;
});

;// CONCATENATED MODULE: ./src/modules/auth/components/PasswordRecoverySteps/StepWrapper/index.tsx









const StepWrapper = (param)=>{
    let { children , step , onSubmit =()=>null , isSubmitting =false  } = param;
    const { currentStep  } = usePasswordRecovery();
    const handleSubmit = (event)=>{
        event.preventDefault();
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    };
    const submitButtonTitle = (0,react.useMemo)(()=>{
        return ({
            1: "Continuar",
            2: "Recuperar",
            3: "Continuar",
            4: "Redefinir"
        })[currentStep];
    }, [
        currentStep
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Container, {
        onSubmit: handleSubmit,
        currentStep: currentStep,
        step: step,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapse/* Collapse */.U, {
            isOpen: currentStep === step,
            startingHeight: 100,
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    type: "submit",
                    mt: "md",
                    size: "lg",
                    isLoading: isSubmitting,
                    children: submitButtonTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthLink/* AuthLink */.g, {
                    href: routes/* routes.AUTH.SIGN_IN */._.AUTH.SIGN_IN,
                    icon: fi_index_esm/* FiArrowLeft */.Ao2,
                    title: "Voltar para o login"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/auth/components/PasswordRecoverySteps/StepTwo/index.tsx












const formSchemaValidation = (selectedMethod)=>{
    if (selectedMethod === "email") {
        return es/* object */.Ry().shape({
            value: es/* string */.Z_().email("E-mail inv\xe1lido").required("E-mail \xe9 obrigat\xf3rio")
        });
    }
    return es/* object */.Ry().shape({
        value: es/* string */.Z_().phoneNumber("Telefone inv\xe1lido").required("Telefone \xe9 obrigat\xf3rio")
    });
};
const BaseStepTwo = ()=>{
    const { currentStep , selectedMethod , sendRecoveryCodeError , sendRecoveryCode , selectedMethodOption , changeMethod  } = usePasswordRecovery();
    const { control , formState: { errors , isSubmitting  } , setValue , handleSubmit , setError  } = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(formSchemaValidation(selectedMethod)),
        defaultValues: {
            value: ""
        }
    });
    (0,react.useEffect)(()=>{
        if (currentStep === 1) {
            setValue("value", "");
            setError("value", {
                message: ""
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentStep
    ]);
    (0,react.useEffect)(()=>{
        if (typeof sendRecoveryCodeError !== "undefined") {
            setError("value", {
                message: sendRecoveryCodeError
            });
        }
    }, [
        sendRecoveryCodeError,
        setError
    ]);
    const handleChangeValue = (event)=>{
        const { value  } = event.target;
        if (selectedMethod === "email") {
            setValue("value", value, {
                shouldValidate: true
            });
        } else {
            setValue("value", (0,masks/* maskCellPhone */.JQ)((0,masks/* unmask */.ec)(value)), {
                shouldValidate: true
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepWrapper, {
        step: 2,
        onSubmit: handleSubmit(sendRecoveryCode),
        isSubmitting: isSubmitting,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* CustomRadio */.r, {
                    ...selectedMethodOption,
                    description: "Clique para alterar a forma",
                    customEndIcon: fi_index_esm/* FiChevronRight */.Tfp,
                    onClick: changeMethod
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledInput/* ControlledInput */.B, {
                    control: control,
                    name: "value",
                    size: "lg",
                    onChange: handleChangeValue,
                    error: errors.value,
                    disableHookFormOnChange: true,
                    maxLength: selectedMethod !== "email" && 16,
                    placeholder: selectedMethod === "email" ? "Digite o seu e-mail" : "Digite o seu telefone"
                })
            })
        ]
    });
};
const StepTwo = /*#__PURE__*/ (0,react.memo)(BaseStepTwo);

;// CONCATENATED MODULE: ./src/shared/components/Form/OTPInput/styles.ts

function OTPInput_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  > div {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: ",
        ";\n  }\n"
    ]);
    OTPInput_styles_templateObject = function() {
        return data;
    };
    return data;
}

const OTPInput_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c917061b-0"
})(OTPInput_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.spacing.sm;
});

;// CONCATENATED MODULE: ./src/shared/components/Form/OTPInput/SingleOTPInput/styles.ts

function SingleOTPInput_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n\n  background: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n\n  padding: ",
        ";\n  font-size: ",
        ";\n  text-align: center;\n  color: ",
        ";\n  text-transform: uppercase;\n\n  transition: all ease-in 0.3s;\n\n  &:disabled {\n    background-color: ",
        ";\n  }\n"
    ]);
    SingleOTPInput_styles_templateObject = function() {
        return data;
    };
    return data;
}

const getHeight = {
    lg: "48px",
    md: "42px",
    sm: "36px"
};
const StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-d1f35b0a-0"
})(SingleOTPInput_styles_templateObject(), (param)=>{
    let { inputSize  } = param;
    return getHeight[inputSize];
}, (param)=>{
    let { inputSize  } = param;
    return getHeight[inputSize];
}, (param)=>{
    let { theme  } = param;
    return theme.colors.surface;
}, (param)=>{
    let { theme , hasError  } = param;
    return "1px solid ".concat(hasError ? theme.colors.danger : theme.colors.gray[100]);
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.sm;
}, (param)=>{
    let { theme , inputSize  } = param;
    return "0 ".concat(inputSize === "lg" ? theme.spacing.sm : "12px");
}, (param)=>{
    let { inputSize  } = param;
    return inputSize === "sm" ? "12px" : "14px";
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.gray[50];
});

;// CONCATENATED MODULE: ./src/shared/components/Form/OTPInput/SingleOTPInput/index.tsx



const BaseSingleOTPInput = (param)=>{
    let { focus , size ="md" , hasError , value ="" , ...rest } = param;
    const inputRef = (0,react.useRef)(null);
    const [focused, setFocused] = (0,react.useState)(false);
    const handleFocusInNative = ()=>{
        if (!inputRef.current) return;
        inputRef.current.setSelectionRange(0, 1);
        if (!focus) return;
        inputRef.current.focus();
        inputRef.current.select();
    };
    handleFocusInNative();
    (0,react.useEffect)(()=>{
        if (!inputRef.current) return;
        if (focused) {
            handleFocusInNative();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        focused
    ]);
    const handleFocus = ()=>{
        setFocused(true);
    };
    const handleBlur = ()=>{
        setFocused(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
        ref: inputRef,
        inputSize: size,
        hasError: hasError,
        onFocus: handleFocus,
        onBlur: handleBlur,
        value: value,
        autoCorrect: "one-time-code",
        onSelect: handleFocusInNative,
        ...rest,
        type: "text"
    });
};
const SingleOTPInput = /*#__PURE__*/ (0,react.memo)(BaseSingleOTPInput);

// EXTERNAL MODULE: ./src/shared/components/Form/Label/index.tsx + 1 modules
var Label = __webpack_require__(26314);
// EXTERNAL MODULE: ./src/shared/components/Form/ErrorMessage/index.tsx + 1 modules
var ErrorMessage = __webpack_require__(20840);
;// CONCATENATED MODULE: ./src/shared/components/Form/OTPInput/index.tsx
/* eslint-disable react/no-array-index-key */ 





const BaseOTPInput = (param)=>{
    let { length =6 , disabled , onChange , error , label , value , size ="md"  } = param;
    const baseOTPValues = (0,react.useMemo)(()=>{
        return Array(length).fill("");
    }, [
        length
    ]);
    const [activeInput, setActiveInput] = (0,react.useState)(0);
    const [OTPValues, setOTPValues] = (0,react.useState)(baseOTPValues);
    const formatOTPValues = (0,react.useCallback)(()=>{
        if (typeof value !== "string") return OTPValues;
        const newOTPValues = value.split("");
        const formattedOTPValues = baseOTPValues.map((_, index)=>{
            return (newOTPValues[index] || "").substring(0, 1) || "";
        });
        return formattedOTPValues;
    }, [
        OTPValues,
        baseOTPValues,
        value
    ]);
    const handleOTPChange = (0,react.useCallback)((otp)=>{
        const otpValue = otp.join("").toUpperCase();
        onChange(otpValue);
    }, [
        onChange
    ]);
    const changeCodeAtFocus = (0,react.useCallback)((str)=>{
        setOTPValues(()=>{
            var ref;
            const formattedOTPValues = formatOTPValues();
            formattedOTPValues[activeInput] = ((ref = str[0]) === null || ref === void 0 ? void 0 : ref.toUpperCase()) || "";
            handleOTPChange(formattedOTPValues);
            return formattedOTPValues;
        });
    }, [
        activeInput,
        formatOTPValues,
        handleOTPChange
    ]);
    const focusInput = (0,react.useCallback)((inputIndex)=>{
        const selectedIndex = Math.max(Math.min(length - 1, inputIndex), 0);
        setActiveInput(selectedIndex);
    }, [
        length
    ]);
    const focusPrevInput = (0,react.useCallback)(()=>{
        focusInput(activeInput - 1);
    }, [
        activeInput,
        focusInput
    ]);
    const focusNextInput = (0,react.useCallback)(()=>{
        focusInput(activeInput + 1);
    }, [
        activeInput,
        focusInput
    ]);
    const handleOnFocus = (0,react.useCallback)((index)=>()=>{
            focusInput(index);
        }, [
        focusInput
    ]);
    const handleOnChange = (0,react.useCallback)((e)=>{
        var ref;
        const val = ((ref = e.currentTarget) === null || ref === void 0 ? void 0 : ref.value) || "";
        if (!val) {
            e.preventDefault();
            return;
        }
        changeCodeAtFocus(val);
        focusNextInput();
    }, [
        changeCodeAtFocus,
        focusNextInput
    ]);
    const onBlur = (0,react.useCallback)(()=>{
        setActiveInput(-1);
    }, []);
    const handleOnKeyDown = (0,react.useCallback)((e)=>{
        const pressedKey = e.key;
        switch(pressedKey){
            case "Backspace":
            case "Delete":
                {
                    e.preventDefault();
                    if (OTPValues[activeInput]) {
                        changeCodeAtFocus("");
                    } else {
                        focusPrevInput();
                    }
                    break;
                }
            case "ArrowLeft":
                {
                    e.preventDefault();
                    focusPrevInput();
                    break;
                }
            case "ArrowRight":
                {
                    e.preventDefault();
                    focusNextInput();
                    break;
                }
            default:
                {
                    if (pressedKey.match(/^[^a-zA-Z0-9]$/)) {
                        e.preventDefault();
                    }
                    break;
                }
        }
    }, [
        activeInput,
        changeCodeAtFocus,
        focusNextInput,
        focusPrevInput,
        OTPValues
    ]);
    const handleOnPaste = (0,react.useCallback)((e)=>{
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text/plain").trim().slice(0, length - activeInput).split("");
        if (pastedData) {
            setOTPValues(()=>{
                let nextFocusIndex = 0;
                const formattedOTPValues = formatOTPValues();
                formattedOTPValues.forEach((val, index)=>{
                    if (index >= activeInput) {
                        const changedValue = pastedData.shift() || val;
                        if (changedValue) {
                            formattedOTPValues[index] = changedValue.toUpperCase();
                            nextFocusIndex = index;
                        }
                    }
                });
                handleOTPChange(formattedOTPValues);
                setActiveInput(Math.min(nextFocusIndex + 1, length - 1));
                return formattedOTPValues;
            });
        }
    }, [
        length,
        activeInput,
        formatOTPValues,
        handleOTPChange
    ]);
    const finalOTPValues = (0,react.useMemo)(formatOTPValues, [
        formatOTPValues
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OTPInput_styles_Container, {
        children: [
            !!label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* Label */._, {
                mb: "xxs",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: Array(length).fill("").map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SingleOTPInput, {
                        hasError: !!error,
                        size: size,
                        focus: activeInput === index,
                        value: finalOTPValues[index] || "",
                        onFocus: handleOnFocus(index),
                        onChange: handleOnChange,
                        onKeyDown: handleOnKeyDown,
                        onBlur: onBlur,
                        onPaste: handleOnPaste,
                        disabled: disabled
                    }, "SingleOTPInput-".concat(index)))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                mt: "xxs",
                children: error
            })
        ]
    });
};
const OTPInput = /*#__PURE__*/ (0,react.memo)(BaseOTPInput);

;// CONCATENATED MODULE: ./src/shared/components/Form/ControlledOTPInput/index.tsx



const ControlledOTPInput = (param)=>{
    let { control , name , error , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
        name: name,
        control: control,
        render: (param)=>{
            let { field: { onChange , value  }  } = param;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OTPInput, {
                ...props,
                value: value,
                error: (error === null || error === void 0 ? void 0 : error.message) || "",
                onChange: onChange
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/modules/auth/components/PasswordRecoverySteps/StepThree/index.tsx











const StepThree_formSchemaValidation = es/* object */.Ry().shape({
    code: es/* string */.Z_().required("C\xf3digo de recupera\xe7\xe3o \xe9 obrigat\xf3rio").min(6, "C\xf3digo de recupera\xe7\xe3o inv\xe1lido")
});
const BaseStepThree = ()=>{
    var ref;
    const { validateRecoveryCode , recoveryCodeIsValidating , validateRecoveryCodeError , selectedMethodOption , changeMethod , currentStep  } = usePasswordRecovery();
    const isValidatingAtFirstTime = (0,react.useRef)(true);
    const { control , formState: { errors  } , handleSubmit , setValue , setError , watch  } = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(StepThree_formSchemaValidation),
        defaultValues: {
            code: ""
        }
    });
    const code = watch === null || watch === void 0 ? void 0 : (ref = watch()) === null || ref === void 0 ? void 0 : ref.code;
    (0,react.useEffect)(()=>{
        if (currentStep < 3) {
            isValidatingAtFirstTime.current = true;
            setValue("code", "");
            setError("code", {
                message: ""
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentStep
    ]);
    (0,react.useEffect)(()=>{
        if (isValidatingAtFirstTime.current && (code === null || code === void 0 ? void 0 : code.length) === 6) {
            isValidatingAtFirstTime.current = false;
            validateRecoveryCode({
                code
            });
        }
    }, [
        code,
        validateRecoveryCode
    ]);
    (0,react.useEffect)(()=>{
        if (typeof validateRecoveryCodeError !== "undefined") {
            setError("code", {
                message: validateRecoveryCodeError
            });
        }
    }, [
        validateRecoveryCodeError,
        setError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepWrapper, {
        step: 3,
        onSubmit: handleSubmit(validateRecoveryCode),
        isSubmitting: recoveryCodeIsValidating,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* FormGroup */.c, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* CustomRadio */.r, {
                        ...selectedMethodOption,
                        description: "Clique para alterar a forma",
                        customEndIcon: fi_index_esm/* FiChevronRight */.Tfp,
                        onClick: changeMethod
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledOTPInput, {
                    control: control,
                    name: "code",
                    size: "lg",
                    error: errors.code,
                    disabled: recoveryCodeIsValidating
                })
            ]
        })
    });
};
const StepThree = /*#__PURE__*/ (0,react.memo)(BaseStepThree);

// EXTERNAL MODULE: ./src/shared/components/Form/ControlledCustomRadioSelector/index.tsx + 3 modules
var ControlledCustomRadioSelector = __webpack_require__(84698);
;// CONCATENATED MODULE: ./src/modules/auth/components/PasswordRecoverySteps/StepOne/index.tsx










const StepOne_formSchemaValidation = es/* object */.Ry().shape({
    method: es/* string */.Z_().required("Selecione uma forma de recupera\xe7\xe3o").nullable()
});
const BaseStepOne = ()=>{
    const { nextStep  } = usePasswordRecovery();
    const { control , formState: { errors  } , handleSubmit  } = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(StepOne_formSchemaValidation),
        defaultValues: {
            method: null
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepWrapper, {
        step: 1,
        onSubmit: handleSubmit(nextStep),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledCustomRadioSelector/* ControlledCustomRadioSelector */.c, {
                control: control,
                name: "method",
                options: passwordRecoveryMethodsOptions,
                error: errors.method
            })
        })
    });
};
const StepOne = /*#__PURE__*/ (0,react.memo)(BaseStepOne);

;// CONCATENATED MODULE: ./src/modules/auth/components/PasswordRecoverySteps/StepFour/index.tsx









const StepFour_formSchemaValidation = es/* object */.Ry().shape({
    newPassword: es/* string */.Z_().required("Nova senha \xe9 obrigat\xf3rio"),
    newPasswordConfirmation: es/* string */.Z_().required("Confirma\xe7\xe3o da nova senha \xe9 obrigat\xf3rio").oneOf([
        es/* ref */.iH("newPassword"),
        null
    ], "A confirma\xe7\xe3o da nova senha n\xe3o confere")
});
const BaseStepFour = ()=>{
    const { resetPassword  } = usePasswordRecovery();
    const { control , formState: { errors , isSubmitting  } , handleSubmit  } = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(StepFour_formSchemaValidation),
        defaultValues: {
            newPassword: "",
            newPasswordConfirmation: ""
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepWrapper, {
        step: 4,
        onSubmit: handleSubmit(resetPassword),
        isSubmitting: isSubmitting,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledInput/* ControlledInput */.B, {
                    control: control,
                    name: "newPassword",
                    placeholder: "Digite sua nova senha",
                    type: "password",
                    error: errors.newPassword,
                    autoComplete: "new-password",
                    size: "lg"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledInput/* ControlledInput */.B, {
                    control: control,
                    name: "newPasswordConfirmation",
                    error: errors.newPasswordConfirmation,
                    type: "password",
                    placeholder: "Digite sua nova senha novamente",
                    autoComplete: "new-password",
                    size: "lg"
                })
            })
        ]
    });
};
const StepFour = /*#__PURE__*/ (0,react.memo)(BaseStepFour);

;// CONCATENATED MODULE: ./src/modules/auth/components/PasswordRecoverySteps/index.tsx








const PasswordRecoverySteps = ()=>{
    const { currentStep  } = usePasswordRecovery();
    const [containerRef, { width: containerWidth  }] = (0,useElementSize/* useElementSize */.h)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        ref: containerRef,
        width: containerWidth,
        currentStep: currentStep,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepOne, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepTwo, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepThree, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepFour, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/auth/pages/PasswordRecovery/styles.ts

function PasswordRecovery_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n"
    ]);
    PasswordRecovery_styles_templateObject = function() {
        return data;
    };
    return data;
}

const PasswordRecovery_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6786a673-0"
})(PasswordRecovery_styles_templateObject());

;// CONCATENATED MODULE: ./src/modules/auth/pages/PasswordRecovery/index.tsx






const PasswordRecovery = ()=>{
    const { currentStep , selectedMethod  } = usePasswordRecovery();
    const headerSubtitle = (0,react.useMemo)(()=>{
        return ({
            1: "Qual a forma de recupera\xe7\xe3o?",
            2: selectedMethod === "email" ? "Informe seu e-mail para enviarmos um c\xf3digo de recupera\xe7\xe3o" : "Informe seu telefone para enviarmos um c\xf3digo de recupera\xe7\xe3o",
            3: "Qual o c\xf3digo de recupera\xe7\xe3o?",
            4: "Escolha uma nova senha segura"
        })[currentStep];
    }, [
        currentStep,
        selectedMethod
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PasswordRecovery_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthHeader/* AuthHeader */.k, {
                title: "Recupere sua conta",
                subtitle: headerSubtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordRecoverySteps, {})
        ]
    });
};

;// CONCATENATED MODULE: ./pages/password-recovery.tsx



const PasswordRecoveryPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordRecoveryProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordRecovery, {})
    });
};
var __N_SSP = true;
/* harmony default export */ var password_recovery = (PasswordRecoveryPage);


/***/ }),

/***/ 84698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ ControlledCustomRadioSelector; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/shared/components/Form/CustomRadioSelector/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: ",
        ";\n  flex-direction: ",
        ";\n\n  > * {\n    min-width: 200px;\n    flex: 1;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8d46e0dd-0"
})(_templateObject());
const OptionsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8d46e0dd-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.spacing.md;
}, (param)=>{
    let { direction  } = param;
    return direction;
});

// EXTERNAL MODULE: ./src/shared/components/Form/Label/index.tsx + 1 modules
var Label = __webpack_require__(26314);
// EXTERNAL MODULE: ./src/shared/components/Form/ErrorMessage/index.tsx + 1 modules
var ErrorMessage = __webpack_require__(20840);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 2 modules
var dist_index_esm = __webpack_require__(71099);
// EXTERNAL MODULE: ./src/shared/components/Form/CustomRadio/styles.ts
var styles = __webpack_require__(34482);
;// CONCATENATED MODULE: ./src/shared/components/Form/CustomRadioLoading/index.tsx



const CustomRadioLoading = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Container */.W2, {
        checked: false,
        hasError: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            type: "button",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IconWrapper */.a1, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* SkeletonCircle */.s7, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Content */.VY, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                    height: "10px",
                                    width: "100px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                    height: "10px",
                                    width: "200px"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* RightElementContainer */.J$, {
                    checked: false,
                    hasError: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* SkeletonCircle */.s7, {
                        size: "4"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/shared/components/Form/CustomRadio/index.tsx
var CustomRadio = __webpack_require__(54815);
;// CONCATENATED MODULE: ./src/shared/components/Form/CustomRadioSelector/index.tsx






const CustomRadioSelector = (param)=>{
    let { label , error , hasError: _hasError = false , options , value , onChange , direction ="row" , isLoading =false  } = param;
    const hasError = !!error || _hasError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            !!label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* Label */._, {
                mb: "xxs",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsWrapper, {
                direction: direction,
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadioLoading, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadioLoading, {})
                    ]
                }) : options.map((option, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* CustomRadio */.r, {
                        title: option.title,
                        description: option.description,
                        hasError: hasError,
                        icon: option.icon,
                        onClick: ()=>onChange(option.value),
                        checked: value === option.value
                    }, String("".concat(option.title, "-").concat(index))))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                mt: "xxs",
                children: error
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Form/ControlledCustomRadioSelector/index.tsx



const ControlledCustomRadioSelector = (param)=>{
    let { control , name , error , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        control: control,
        render: (param)=>{
            let { field: { onChange , value  }  } = param;
            const handleChange = (option)=>{
                var ref;
                onChange === null || onChange === void 0 ? void 0 : onChange(option);
                (ref = props.onChange) === null || ref === void 0 ? void 0 : ref.call(props, option);
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadioSelector, {
                ...props,
                value: value,
                error: (error === null || error === void 0 ? void 0 : error.message) || "",
                onChange: handleChange
            });
        }
    });
};


/***/ }),

/***/ 54815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ CustomRadio; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86893);
/* harmony import */ var _shared_components_Tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10554);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34482);




const CustomRadio = (param)=>{
    let { onClick , tooltip , title , description , icon: Icon , checked =false , hasError =false , customEndIcon: CustomEndIcon  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        checked: checked,
        hasError: hasError,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_components_Tooltip__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
            label: tooltip,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                onClick: onClick,
                children: [
                    !!Icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .IconWrapper */ .a1, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: title
                                }),
                                !!description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: description
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RightElementContainer */ .J$, {
                        checked: checked,
                        hasError: hasError,
                        children: CustomEndIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomEndIcon, {}) : checked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_3__/* .FiCheckCircle */ ._rq, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_3__/* .FiCircle */ .Q8x, {})
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 34482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J$": function() { return /* binding */ RightElementContainer; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "a1": function() { return /* binding */ IconWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96502);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        border-color: ",
        ";\n        background-color: ",
        ";\n\n        svg {\n          color: ",
        " !important;\n        }\n      "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  > button {\n    width: 100%;\n\n    cursor: pointer;\n\n    min-height: 68px;\n\n    border-radius: ",
        ";\n    padding: ",
        ";\n    border: ",
        ";\n    background: ",
        ";\n\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n\n    transition: all ease-in 0.3s;\n\n    &:hover {\n      filter: brightness(0.98);\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: 17.5px;\n    height: 17.5px;\n    color: ",
        ";\n    transition: color ease-in 0.3s;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 68px;\n  color: ",
        ";\n  margin-right: auto;\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n\n    max-width: 100%;\n\n    > strong {\n      font-size: 12px;\n      color: ",
        ";\n      font-weight: 600;\n      line-height: 12px;\n      text-align: left;\n\n      margin-right: auto;\n    }\n\n    > p {\n      color: ",
        ";\n      font-size: 12px;\n      line-height: 14px;\n      font-weight: 300;\n      text-align: left;\n      margin-top: 4px;\n\n      margin-right: auto;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 20px;\n  min-width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: 16px;\n    height: 16px;\n    color: ",
        " !important;\n    transition: color ease-in 0.3s;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b339429-0"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.borderRadius.sm;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.sm;
}, (param)=>{
    let { theme , hasError  } = param;
    return "1px solid ".concat(hasError ? theme.colors.danger : theme.colors.gray[100]);
}, (param)=>{
    let { theme  } = param;
    return theme.colors.surface;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.sm;
}, (param)=>{
    let { checked , theme  } = param;
    return checked && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject(), theme.colors.primary, (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(0.96, theme.colors.primary), theme.colors.primary);
});
const IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b339429-1"
})(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
});
const Content = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b339429-2"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
});
const RightElementContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b339429-3"
})(_templateObject4(), (param)=>{
    let { theme , hasError  } = param;
    return hasError ? theme.colors.danger : theme.colors.gray[200];
});


/***/ }),

/***/ 83896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ useElementSize; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/shared/hooks/useIsomorphicLayoutEffect.ts

const useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;

;// CONCATENATED MODULE: ./src/shared/hooks/useEventListener.ts
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable consistent-return */ 

function useEventListener(eventName, handler, element) {
    // Create a ref that stores handler
    const savedHandler = (0,react.useRef)(handler);
    useIsomorphicLayoutEffect(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0,react.useEffect)(()=>{
        // Define the listening target
        const targetElement = element || (element === null || element === void 0 ? void 0 : element.current) || window;
        if (!(targetElement && targetElement.addEventListener)) {
            return;
        }
        // Create event listener that calls handler function stored in ref
        const eventListener = (event)=>savedHandler.current(event);
        targetElement.addEventListener(eventName, eventListener);
        // Remove event listener on cleanup
        return ()=>{
            targetElement.removeEventListener(eventName, eventListener);
        };
    }, [
        eventName,
        element
    ]);
}

;// CONCATENATED MODULE: ./src/shared/hooks/useElementSize.ts



function useElementSize() {
    const [ref, setRef] = (0,react.useState)(null);
    const [size, setSize] = (0,react.useState)({
        width: 0,
        height: 0
    });
    const handleSize = (0,react.useCallback)(()=>{
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0
        });
    }, [
        ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
        ref === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    useEventListener("resize", handleSize);
    useIsomorphicLayoutEffect(()=>{
        handleSize();
    }, [
        ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
        ref === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    return [
        setRef,
        size
    ];
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3609,7536,2735,9774,2888,179], function() { return __webpack_exec__(74474); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);